import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const JobDetailPage = lazy(() => import('../pages/job-detail/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const BusinessPage = lazy(() => import('../pages/business/page'));
const AccessPage = lazy(() => import('../pages/access/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const ProcessPage = lazy(() => import('../pages/process/page'));
const BenefitsPage = lazy(() => import('../pages/benefits/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const SitemapPage = lazy(() => import('../pages/sitemap/page'));
const WorkplacePage = lazy(() => import('../pages/workplace/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/jobs/:jobId', element: <JobDetailPage /> },
  { path: '/about', element: <AboutPage /> },
  { path: '/business', element: <BusinessPage /> },
  { path: '/access', element: <AccessPage /> },
  { path: '/contact', element: <ContactPage /> },
  { path: '/process', element: <ProcessPage /> },
  { path: '/benefits', element: <BenefitsPage /> },
  { path: '/privacy', element: <PrivacyPage /> },
  { path: '/sitemap', element: <SitemapPage /> },
  { path: '/workplace', element: <WorkplacePage /> },
  { path: '*', element: <NotFoundPage /> },
];

export default routes;